/** Régua do financeiro: 1 fatura 0%, 2 = 10%, 3 = 20%, 4 ou mais = 30%. Qtd conta só faturas com valor > 0. */
export function percentualRegua(qtd: number): number {
  if (qtd >= 4) return 30;
  if (qtd === 3) return 20;
  if (qtd === 2) return 10;
  return 0;
}

/** Espelha Math.Round(total * (100 - p) / 100, 2, AwayFromZero) do back, em centavos inteiros. */
export function comDesconto(valor: number, percentual: number): number {
  const centavos = Math.round(valor * 100);
  const sinal = centavos < 0 ? -1 : 1;
  const produto = Math.abs(centavos) * (100 - percentual);
  return (sinal * Math.floor((produto + 50) / 100)) / 100;
}
